import Image from 'next/image'

import NormalRankImage from 'public/images/ranks/normal.png'
import GoldRankImage from 'public/images/ranks/gold.png'
import PlatinumRankImage from 'public/images/ranks/platinum.png'

const RANK_IMAGES: Record<number, typeof NormalRankImage> = {
  1: NormalRankImage,
  2: GoldRankImage,
  3: PlatinumRankImage,
}

interface RankMedalProps {
  rankNumber?: number
  rankName?: string
  size?: number
  className?: string
}

const RankMedal: React.FunctionComponent<RankMedalProps> = ({
  rankNumber,
  rankName,
  size = 40,
  className,
}) => {
  const image = rankNumber ? RANK_IMAGES[rankNumber] : undefined

  if (!image) return null

  return (
    <Image
      src={image}
      alt={rankName || ''}
      width={size}
      height={size}
      className={className}
    />
  )
}

export default RankMedal
